import { makeStyles } from "@material-ui/core";
import Suche from "./Suche";

export default function ErweiterteSuchleiste() {
  const classes = useStyle();

  return (
    <div className={classes.container}>
      <div className={classes.filternUnSuchenContainer}>
        <Suche />
      </div>
    </div>
  );
}

const useStyle = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    background: "white",
    margin: 0,
    padding: 10,
    borderRadius: 10,
    border: "1px solid rgb(228,230,235)",
    boxShadow: "rgba(9,32,77,0.12) 0px 3px 8px rgba(29,17,51,0.12) 0px 0px 2px",
    backgroundColor: "white",
  },
  filternUnSuchenContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
  },
  clearButton: {
    cursor: "pointer",
    padding: 5,
  },
  separator: {
    borderLeft: "1px solid rgb(240, 240, 240)",
    alignSelf: "stretch",
    margin: "5px 0.5rem",
    marginLeft: 10,
    marginRight: 10,
  },
});
